import React from "react";
import FeatherIcon from "feather-icons-react";
import "../sass/primary.scss";

const Title = ({ title, closeMenu, onToggleExpand, isExpanded }) => {
  return (
    <div className="rightsidebar-content-header">
      <h3 className="rightsidebar-content-header-title">{title}</h3>
      <div className="d-flex align-items-center" style={{ gap: "8px" }}>
        {typeof onToggleExpand === "function" && (
          <button
            type="button"
            onClick={onToggleExpand}
            className="rightsidebar-header-icon-btn"
            title={isExpanded ? "Contraer" : "Expandir"}
          >
            <FeatherIcon
              icon={isExpanded ? "minimize-2" : "maximize-2"}
              size={20}
              strokeWidth={2}
            />
          </button>
        )}
        <button
          type="button"
          onClick={closeMenu}
          className="rightsidebar-header-icon-btn cursor-pointer"
          title="Cerrar"
        >
          <FeatherIcon icon="x" size={20} strokeWidth={2} />
        </button>
      </div>
    </div>
  );
};

export default Title;
